import { createBrowserRouter, Navigate } from "react-router-dom";
import StationsRedirect from "./StationsRedirect";
import Entry from "../pages/Entry";
import Register from "../pages/Register";
import Login from "../pages/Login";
import Hub from "../pages/Hub";
import InBody from "../pages/InBody";
import Clan from "../pages/Clan";
import Rowing from "../pages/Rowing";
import TaskDetail from "../pages/TaskDetail";
import Profile from "../pages/Profile";
import Done from "../pages/Done";
import Coach from "../pages/Coach";
import Leaderboard from "../pages/Leaderboard";
import Prizes from "../pages/Prizes";
import Admin from "../pages/Admin";
import StaffGate from "../components/StaffGate";

export const router = createBrowserRouter(
  [
    // Онбординг — язык выбирается прямо на нём; /start оставлен для старых ссылок.
    { path: "/", element: <Entry /> },
    { path: "/start", element: <Entry /> },
    // Публичная витрина призов (и вкладка таббара после входа).
    { path: "/prizes", element: <Prizes /> },
    { path: "/register", element: <Register /> },
    { path: "/login", element: <Login /> },
    { path: "/hub", element: <Hub /> },
    // Вкладка «Зоны» слита с главной; старые ссылки ведут на хаб (номер сохраняем).
    { path: "/stations", element: <StationsRedirect /> },
    // Зона 1: мой результат + live-лидерборд (мобильная версия ТВ-лидерборда).
    { path: "/rowing", element: <Rowing /> },
    { path: "/profile", element: <Profile /> },
    { path: "/inbody", element: <InBody /> },
    { path: "/clan", element: <Clan /> },
    // Детальная страница кланового задания (фото + описание).
    { path: "/task/:key", element: <TaskDetail /> },
    { path: "/clan/create", element: <Clan /> },
    { path: "/clan/join", element: <Clan /> },
    { path: "/done", element: <Done /> },
    { path: "/coach", element: <StaffGate><Coach /></StaffGate> },
    // Публичный лидерборд (TV + гости) — без стафф-гейта, показывается весь фестиваль.
    { path: "/leaderboard", element: <Leaderboard /> },
    { path: "/admin", element: <StaffGate><Admin /></StaffGate> },
    // Старая ссылка на /cabinet ведёт на хаб.
    { path: "/cabinet", element: <Navigate to="/hub" replace /> },
  ],
  { basename: __BASE_PATH__ },
);
